export const defaultFilters = () => ({
    tags: [],
    createdBy: [],
    visibility: null,
    createdDate: null,
    titles: [],
    categories: [],
    years: [],
});